import { guidEmpty } from 'utils/guid-empty';

export class ParametroVisualizacaoRequestModel {
  constructor(
    public id: string = guidEmpty(),
    public valor: string = '',
  ) {}
}
